import React from "react";

const VersionTag = ({ data }: { data: { version: string } }) => {
  return (
    <span className="invisible" id="mixer-hybrid-version">
      {data.version}
    </span>
  );
};

export default VersionTag;
